import React from "react";
import "./Layout.css";
import Menus from "../Menus/Menus";

const Layout = () => {
  return (
    <>
      <div className="navbar-section">
        <div className="top-navbar">
          <div className="navbar-brand">
            <h2 className="brand-logo">Portfolio</h2>
          </div>
          <Menus />
        </div>
      </div>
    </>
  );
};

export default Layout;
